import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "./Redux/store";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import captureUserToken from "./Utils/captureUserToken";

// Must run before render so the router and API calls see the stored token, not the URL one
captureUserToken();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

reportWebVitals();
